export default __webpack_public_path__ + "static/media/hht2_ep12_book_wp_02.59b5ab55.jpg";